import React, { Component } from 'react';
import { Link } from 'gatsby';
import { Image, Wrapper } from '.';
import { getExcerpt } from '../util/helpers';
import './RelatedStoriesBlock.scss';

class RelatedStoriesBlock extends Component {
  render() {
    const {
      headline,
      relatedStories,
      siteMetadata,
    } = this.props;
    const {
      storiesSlug,
    } = siteMetadata;
    const { edges } = relatedStories;
    const relatedStoriesItems = edges.map(storyItem => storyItem.node);
    if (!relatedStoriesItems || relatedStoriesItems.length < 1) return null;
    return (
      <section className="related-stories-block">
        <Wrapper>
          <h2 className="headline">{headline}</h2>
          <div className="container">
            <div className="stories">
              {relatedStoriesItems && relatedStoriesItems.map((storyItem) => {
                const { slug } = storyItem;
                const storyData = storyItem.data || {};
                const {
                  storyName,
                  narrative,
                  featuredImage,
                } = storyData;
                return (
                  <Link
                    className="story"
                    key={slug}
                    to={`/${storiesSlug}/${slug}/`}
                    aria-label={`Read more about ${storyName.text}`}
                  >
                    <div className="image-container">
                      <Image image={featuredImage} className="interactive-image cover" />
                    </div>
                    <div className="text-container">
                      <h3 className="title">{storyName.text}</h3>
                      <p className="excerpt">{getExcerpt(narrative.text, 150)}</p>
                      <div className="read-more-button">
                        <svg className="icon" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                          <path d="M18.165 6.673H1.195a.85.85 0 0 0 0 1.7h16.927l-4.89 5.193a.841.841 0 0 0-.193.832.864.864 0 0 0 .638.58.882.882 0 0 0 .833-.251l6.26-6.647a.844.844 0 0 0 .228-.532.842.842 0 0 0-.228-.628L14.51.273a.882.882 0 0 0-.833-.252.864.864 0 0 0-.638.58.841.841 0 0 0 .194.833l4.932 5.239z" fillRule="evenodd" />
                        </svg>
                      </div>
                    </div>
                  </Link>
                );
              })}
            </div>
          </div>
        </Wrapper>
      </section>
    );
  }
}

export default RelatedStoriesBlock;
